export const setItemStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data))
}

export const getItemStorage = (key, defaultValue) => {
  const item = JSON.parse(localStorage.getItem(key))
  return item || defaultValue
}

export const clearStorage = (key) => localStorage.removeItem(key)
